import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
} from "reactstrap";
import { ToastHelper } from "../../../../helpers/alerts/alertHelper";
import { formatFecha } from "../formatFecha";

const preStyle = {
  whiteSpace: "pre-wrap",
  overflowX: "auto",
  maxHeight: "260px",
  fontSize: "12px",
};

const Dato = ({ label, value }) => (
  <Col md={6} className="mb-2">
    <small className="text-muted d-block">{label}</small>
    <span style={{ wordBreak: "break-all" }}>{value ?? "-"}</span>
  </Col>
);

Dato.propTypes = { label: PropTypes.string, value: PropTypes.any };

const DetailModal = ({ modal, setModal }) => {
  const item = modal.item ?? {};

  const handleClose = () => setModal({ show: false, item: null });

  const texto = () =>
    [
      `Folio: #${item.id}`,
      `Fecha: ${formatFecha(item.created_at)}`,
      `Origen: ${item.origin ?? "-"}`,
      `Ocurrencias: ${item.occurrences ?? 1}`,
      `Usuario: ${item.user_email ?? "Sin sesión"} (perfil ${item.profile_name ?? "-"})`,
      `Ruta: ${item.route_name ?? "-"}`,
      `Pantalla: ${item.route_path ?? "-"}`,
      `URL: ${item.url ?? "-"}`,
      `User agent: ${item.user_agent ?? "-"}`,
      "",
      `Mensaje: ${item.message ?? "-"}`,
      "",
      "Stack:",
      item.stack ?? "-",
      "",
      "Component stack:",
      item.component_stack ?? "-",
      "",
      "Contexto:",
      JSON.stringify(item.context ?? {}, null, 2),
    ].join("\n");

  const copiar = () => {
    try {
      navigator.clipboard.writeText(texto());
      ToastHelper("Detalle copiado al portapapeles", "success");
    } catch (e) {
      // navigator.clipboard no existe fuera de contextos seguros (http).
      ToastHelper("No se pudo copiar el detalle", "error");
    }
  };

  return (
    <Modal isOpen={modal.show} className="modal-dialog modal-xl">
      <ModalHeader className="bg-primary">
        Error #{item.id} — {item.message}
      </ModalHeader>
      <ModalBody>
        <Row>
          <Dato label="Fecha" value={formatFecha(item.created_at)} />
          <Dato label="Origen" value={item.origin} />
          <Dato label="Ocurrencias" value={item.occurrences} />
          <Dato
            label="Usuario"
            value={item.user_email ?? "Sin sesión"}
          />
          <Dato label="Perfil" value={item.profile_name} />
          <Dato label="Ruta" value={item.route_name} />
          <Dato label="Pantalla" value={item.route_path} />
          <Dato label="URL" value={item.url} />
          <Dato label="Navegador" value={item.user_agent} />
        </Row>

        <hr />

        <h6>Mensaje</h6>
        <pre className="bg-light p-2 text-danger" style={preStyle}>
          {item.message ?? "-"}
        </pre>

        <h6>Stack</h6>
        <pre className="bg-light p-2" style={preStyle}>
          {item.stack ?? "Sin stack"}
        </pre>

        {item.component_stack && (
          <>
            <h6>Componentes de React</h6>
            <pre className="bg-light p-2" style={preStyle}>
              {item.component_stack}
            </pre>
          </>
        )}

        <h6>Contexto</h6>
        <pre className="bg-light p-2" style={preStyle}>
          {JSON.stringify(item.context ?? {}, null, 2)}
        </pre>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={copiar}>
          <i className="fa fa-copy me-1"></i> Copiar todo
        </Button>
        <Button color="secondary" onClick={handleClose}>
          Cerrar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

DetailModal.propTypes = {
  modal: PropTypes.object,
  setModal: PropTypes.func,
};

export default DetailModal;
